import { ReactNode } from "react";
import { Stack } from "@mui/material";
import { useResponsiveBreakpoints } from "src/utils/useResponsiveBreakpoints";

type ScoreSectionProps = {
    children: ReactNode;
};

export const ScoreSection = ({ children }: ScoreSectionProps) => {
    const { isMobile } = useResponsiveBreakpoints();

    return (
        <Stack
            sx={{
                height: "fit-content",
                position: isMobile ? "static" : "sticky",
                top: isMobile ? "auto" : `${96 + 28 * 2}px`,
            }}
        >
            {children}
        </Stack>
    );
};
